import { BarzhaResponse, BarzhaStatusTask, BarzhaStatus } from './types/barzha';
import { Task, TaskStatus } from '../../types';

export class BarzhaAdapter {
  private static readonly BASE_URL = 'https://app.barzha.com';

  static adaptTasks(
    barzhaResponse: BarzhaResponse,
    statusTasks: BarzhaStatusTask[],
  ): Task[] {
    console.log('🔄 BarzhaAdapter.adaptTasks - start', {
      barzhaResponse,
      statusTasks,
    });
    console.log('barzhaResponseeeee', barzhaResponse);
    // Если нет доступных заданий или ответ с ошибкой, возвращаем пустой массив
    if (
      barzhaResponse.status === 'error' ||
      !barzhaResponse.tasks ||
      !Array.isArray(barzhaResponse.tasks)
    ) {
      console.log('ℹ️ Нет доступных заданий от Barzha');
      return [];
    }

    const mapBarzhaStatusToTaskStatus = (status: BarzhaStatus): TaskStatus => {
      switch (status) {
        case BarzhaStatus.Subscribed:
          return 'CLAIMED';
        case BarzhaStatus.Claim:
          return 'DONE';
        case BarzhaStatus.Done:
          return 'CLAIMED';
        case BarzhaStatus.NotStarted:
        case BarzhaStatus.Active:
        default:
          return 'NOT_STARTED';
      }
    };

    return barzhaResponse.tasks
      .map((task) => {
        // Проверяем, есть ли необходимые поля
        if (
          !('title' in task) ||
          !('description' in task) ||
          !('image_href' in task)
        ) {
          console.warn('Skipping task due to missing required fields:', task);
          return null;
        }

        // Ищем задание в статусах
        const statusTask = statusTasks.find(
          (st) => st.task_id === String(task.ad_subscription_campaign_id),
        );

        // Определяем visibility
        const visibility = statusTask ? statusTask.visibility : true;

        // Проверяем условия для отображения задания
        if (statusTask && statusTask.type === 'task' && !visibility) {
          return null; // Не отображаем задание, если тип 'task' и visibility false
        }

        // Определяем статус и текст кнопки
        let status: TaskStatus = mapBarzhaStatusToTaskStatus(
          task.status as BarzhaStatus,
        );
        let buttonText = 'Подписаться';
        console.log('statusBarzha ', task);
        if (task.status === 'subscribed') {
          status = 'CLAIMED';
          buttonText = 'Собрать';
        } else if (task.status == 'done') {
          // status = statusTask.status as TaskStatus;
          status = 'CLAIMED';
          buttonText = 'Выполнено';
          // buttonText =
          //   status === 'DONE' ? 'Собрать' : task.button_text || 'Подписаться';
        }

        return {
          id: task.ad_subscription_campaign_id,
          title: task.title as string,
          description: task.description as string,
          icon: `${this.BASE_URL}${task.image_href as string}`,
          type: 'sponsors',
          rewards: {
            stars: task.rewards.stars,
          },
          status,
          buttonText,
          link: '',
          provider: 'BARZHA',
          visibility: statusTask ? statusTask.visibility : true,
          progress: {
            current: 0,
            total: 1,
          },
        } as Task;
      })
      .filter((task): task is Task => task !== null);
  }
}
